<template>
  <v-main tag="article" :class="classes">
    <!-- 헤더 아래 상단 배너 -->
    <!-- <v-slide-y-transition hide-on-leave>
      <top-header v-if="hasHeader" :style="hasHeader && 'position: absolute'" />
    </v-slide-y-transition> -->

    <slot name="default">
      <transition :name="$route.meta.transition || ''">
        <router-view
          :key="$route.fullPath + '&' + $store.state.time.current"
          :class="{ 'pt-8': hasHeader }"
        />
      </transition>
    </slot>
  </v-main>
</template>

<script>
import TopHeader from './TopHeader.vue'

export default {
  // components: {
  //   TopHeader,
  // },
  data() {
    return {
      ready: false,
    }
  },

  props: {
    fluid: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classes() {
      const result = []
      if (this.fluid === true) {
        result.push('fluid')
      }

      if (!this.$route.meta.design || !this.$route.meta.design.classes) {
        result.push('px-2')
        return result
      }

      if (this.$route?.meta?.design?.classes) {
        return result.concat(this.$route.meta.design.classes)
      }

      return result
    },
    hasHeader() {
      return this.ready && !this.$route?.meta?.design?.noTopHeader
    },
  },

  mounted() {
    setTimeout(() => {
      this.ready = true
    }, 200)
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common/_variables.scss';

article {
  position: relative;
  display: block;
  width: 100%;
  max-width: $standard-max-width;
  min-height: 100svh;
  height: 100%;
  background-color: white;
  margin: 0 auto;

  &.fluid {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
}
</style>
